export enum TipoBeneficio {
    APOSENTADORIAPROGRAMADA = 1,
    APOSENTADORIAINVALIDEZ,
    PENSAOMORTE,
    PECULIOPREVIDENCIARIO,
    PLANOPECULIO,
    ADIANTAMENTOPLANOPECULIO
}
